import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { FILTER, TABLE_DATA, TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { updateTableDataAction, updateTableSchemaAction } from '@/main/store/actionsFunctions';

import { apiProvider } from '../api';
import { CRUMB_LABEL_KEY, VOZIDLO_RIDIC } from '../constants';

export const store = listStoreBuilder({
	name: VOZIDLO_RIDIC,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		VozidloId: null as number | null,
		RidicPrijmeni: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {
		async [TABLE_SCHEMA]({ state, commit, dispatch }, isSelect = false) {
			return updateTableSchemaAction(state, commit, dispatch,
				apiProvider.getVozidloRidicShema(), 'table');
		},
		[TABLE_DATA]: ({ commit, dispatch, state }, { filter = {} }) => (
			updateTableDataAction(state, commit, dispatch,
				apiProvider.getVozidloRidicRows(filter),
				'table')
		),
		[FILTER]: () => ({ data: {} }),
	},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
